import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowExit = () => {
  return (
    <g>
      <path d="m15.6843 7.47-4.97-4.97a.75.75 0 1 0 -1.0603 1.06l3.69 3.69h-9.254a.75.75 0 0 0 0 1.5h9.2539l-3.6898 3.6895a.75.75 0 1 0 1.0605 1.0605l4.97-4.97a.75.75 0 0 0 -.0003-1.06z" />
      <path d="m4.6585 13.875h-3.0625v-11.75h3.0625a.75.75 0 0 0 0-1.5h-3.8125a.75.75 0 0 0 -.75.75v13.25a.75.75 0 0 0 .75.75h3.8125a.75.75 0 0 0 0-1.5z" />
    </g>
  );
};

export default withIcon(IconArrowExit);
